import React from 'react'
import Typography from '../../../Typography'
import Container from '../../../v2/Container'
import Spinner from '../../../Spinner'

const Fetching = () => (
  <Container maxWidth="md" padding={8}>
    <Typography align="center">Looking for your student...</Typography>
    <Container>
      <Spinner color="blue" />
    </Container>
  </Container>
)

export default Fetching
